import { Spinner, StatusChip, Typography, tokens } from '@cast/design-system';
import {
  WorkloadRecommendationStatusTypeEnum,
  type OptimizationWorkloadPod,
} from '@cast/types';

import {
  getPodAppliedStatus,
  type PodAppliedStatus,
} from '../../../_podStatusUtils';

import {
  STATUS_BADGE_COLOR_MAP,
  STATUS_DISPLAY_NAME_MAP,
} from '../../../_constants';

type Props = {
  isLatestRecommendation: boolean;
  recommendation?: OptimizationWorkloadPod['recommendation'];
  // True when BE returns recommendationStatus.type === STATUS_UNKNOWN for the
  // parent workload (vertical autoscaling disabled / not yet provisioned).
  // When true, every pod must render as notApplied regardless of per-pod
  // isLatestRecommendation / appliedAt.
  isOptimizationDisabled?: boolean;
};

const SpinnerIcon = () => (
  <Spinner
    color="inherit"
    thickness={8}
    sx={{
      color: tokens.theme.fg.status.success,

      '& .MuiCircularProgress-circleDeterminate': {
        stroke: tokens.theme.fg.status.neutral,
      },
    }}
    size={12}
  />
);

const NotAppliedGlyph = () => (
  <Typography variant="P12R" sx={{ color: 'grey.400' }}>
    —
  </Typography>
);

const renderStatus = (status: PodAppliedStatus) => {
  if (status === 'applied') {
    return (
      <StatusChip
        sx={
          STATUS_BADGE_COLOR_MAP[WorkloadRecommendationStatusTypeEnum.APPLIED]
        }
        size="md"
      >
        {STATUS_DISPLAY_NAME_MAP[WorkloadRecommendationStatusTypeEnum.APPLIED]}
      </StatusChip>
    );
  }
  if (status === 'pending') {
    return <SpinnerIcon />;
  }
  return <NotAppliedGlyph />;
};

export const StatusCell = ({
  isLatestRecommendation,
  recommendation,
  isOptimizationDisabled,
}: Props) => {
  const status = getPodAppliedStatus(
    { isLatestRecommendation, recommendation },
    isOptimizationDisabled
  );
  return renderStatus(status);
};
